import { CoverArt } from "@/components/CoverArt";
import { fileUrl } from "@/lib/auth";

export const ArticleCover = ({ article, className = "" }) => {
    if (article.cover_image) {
        return (
            <img
                src={fileUrl(article.cover_image)}
                alt={article.title}
                loading="lazy"
                className={`h-full w-full object-cover ${className}`}
            />
        );
    }
    return <CoverArt seed={article.slug} variant={article.cover_style} className={className} />;
};
